import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import preloadOperationsQueryNode from './__generated_stale__/preloadOperationsQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export async function preloadOperations(): Promise<
	| {
			data: unknown;
			errors?: ReadonlyArray<GraphQLErrorInterop>;
			hasErrors: boolean;
	  }
	| undefined
> {
	const { userId } = getPreloaderFnContext();
	if (!userId) {
		return;
	}

	return query({ query: preloadOperationsQueryNode });
}
